<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="申请记录"
      fontSize="0.32rem"
    />
    <div class="pad_t"></div>
    <div class="tips">若新增房产信息已通过审核，请退出账号重新登录进入 <span>我的房源管理</span> 查看。</div>
    <div class="no_data" v-if="!list.length">
      <img src="@/assets/img/nodata.png" alt="">
    </div>
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="inner" v-for="(item, index) in list" :key="index">
            <div class="top m_flex_box flex_jz">
              <h4>权证号：{{item.houseQzh}}</h4>
              <div class="m_flex_box">
              <i class="col_ori">{{item.auditStatus === 0 ? '待审核' : (item. auditStatus === 2 ? '未通过' : '已通过')}}</i>
              </div>
            </div>
            <div class="middle m_flex_box flex_jz">
              <span>{{item.area | format}}</span>
              <span>{{item.auditType == 0 ? '房产新增' : '数据有误'}}</span>
              <span class="time">{{item.createDate | formatTime}}</span>
            </div>
            <div class="info m_flex_box">
              <span class="tit">描述信息：</span>
              <span class="text">{{item.applyMsg || '-'}}</span>
            </div>
            <div v-show="item.auditMsg">
              <div class="info m_flex_box">
                <span class="tit">未通过原因：</span>
                <span class="text">{{item.auditMsg}}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      current: 1,
      isLoading: false,
      loading: false,
      finished: false,
      currPageNo: 1,
      list: []
    };
  },
  filters: {
    formatTime(shijianchuo) {
      if(!shijianchuo) {
        return '';
      }
      var time = new Date(shijianchuo * 1);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      return y + '-'+ m + '-' + d;
    },
    format(data) {
      if (data === "320381") {
        return "新沂市";
      } else if (data === "320382") {
        return "邳州市";
      } else if (data === "320312") {
        return "铜山区";
      } else if (data === "320") {
        return "市区";
      }
    }
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {
    toUrl(path, query){
      this.$router.push({
        path,
        query
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/houseDataChange/reg/getHouseChangList.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            pageSize: 10,
            offset: (this.currPageNo - 1) * 10,
          }
        }).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if(res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.currPageNo = this.currPageNo + 1
          } else {
            this.finished = true;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.pad_t{
  padding-top: 0.88rem;
}
.tips{
  z-index: 3;
  top: 0.9rem;
  position: fixed;
  font-size: 0.24rem;
  color: #856404;
  background-color: #fff3cd;
  padding: 0.12rem 0.23rem;
  span{
    font-weight: 800;
  }
}
.tab_con {
  height: 0.94rem;
  border-bottom: 1px solid #f5f5f5;
  padding-left: 0.23rem;
  background-color: #fff;
  z-index: 2;

  &.fixed {
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
  }
  span {
    font-size: 0.32rem;
    color: #202020;
    line-height: 0.94rem;
    position: relative;
    &.active {
      font-weight: 800;
      &:after {
        content: "";
        display: block;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #2f72f5;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -0.24rem;
      }
    }
  }
}
.bg_gray{
  background-color: #f5f5f5;
  min-height: 100vh;
}
.inner{
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.16rem solid #f5f5f5;
  .top{
    padding-bottom: 0.28rem;
    border-bottom: 1px solid #f5f5f5;
    h4{
      font-size: 0.26rem;
      font-weight: 800;
    }
    i{
      margin-bottom: 0.14rem;
      padding: 0 0.1rem;
      line-height: 0.32rem;
      height: 0.32rem;
      color: #fff;
      font-size: 0.2rem;
      text-align: center;
      display: inline-block;
      margin-right: 0.1rem;
      &.col_ori{
        color: #FF5C3C;
        border: 1px solid currentColor;
      }
      &.col_blue{
        color: #2F72F5;
        border: 1px solid currentColor;
      }
    }
  }
  .middle{
    padding: 0.28rem 0;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;
    .time{
      color: #A0A0A0;
    }
  }
  .info{
    padding: 0.28rem 0;
    font-size: 0.24rem;
    border-bottom: 1px solid #f5f5f5;
    .tit{
      width: 1.6rem;
    }
    .text{
      width: 5.36rem;
    }
  }
}
</style>